export enum AgrupamentosTypes {
  LOAD_REQUEST = '@agrupamentos/LOAD_REQUEST',
  LOAD_SUCCESS = '@agrupamentos/LOAD_SUCCESS',
  LOAD_FAILURE = '@agrupamentos/LOAD_FAILURE',
}

export interface Agrupamentos {
  codParc: number;
  inscricaoEstadual: string;
  nome: string;
  solicIndividual: boolean;
  cnpjCpf: string;
}

export interface AgrupamentosState {
  readonly data: Agrupamentos[];
  readonly loading: boolean;
  readonly error: boolean;
}
